import React, { useState, useEffect } from 'react'
import { SearchDropdown } from '@prosolve/common-components-ui'
import OptionalFormFieldWrapper from './OptionalFormFieldWrapper';
import useFetchImplementations from './useFetchImplementations';

export default ({
  accountId,
  isShowLabel = true,
  value: defaultValue,
  onChange: onChangeParam
}) => {
  const { fetchImplementations: fetchImplementationsHook, isImplementationsLoading } = useFetchImplementations()

  const [value, setValue] = useState(defaultValue)
  const [search, setSearch] = useState(defaultValue)
  const [implementations, setImplementations] = useState([])

  const options = implementations
    .filter(impl => 
      ((search || '').length === 0 ? true : (
        impl.Name.toLowerCase().indexOf(search.toLowerCase()) > -1 ||
        impl.Id.toLowerCase().indexOf(search.toLowerCase()) > -1
      ))
    )
    .map(impl => ({
      text: impl.Name,
      value: impl.Id,
    }))

  const fetchImplementations = async () => {
    const response = await fetchImplementationsHook({ accountId })
    setImplementations(response || [])
    return response || []
  }

  const onChange = (val) => {
    setValue(val)
    if (onChangeParam) onChangeParam(val)
  }

  useEffect(() => {
    async function fetchImpl() {
      if (accountId) {
        const implementations = await fetchImplementations();
        
        if (implementations.length > 0) {
          // How to select the first one?
        }
      } else {
        setImplementations([])
      }
    }
    fetchImpl()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountId])

  return (
    <div style={{ display: 'flex', flexDirection: 'column'}}>
      <OptionalFormFieldWrapper isEnabled={isShowLabel} label={'Implementation'}>
        <SearchDropdown
          value={value}
          options={options}
          onChange={(val) => onChange(val)}
          onSearch={(val) => setSearch(val)}
          isLoading={isImplementationsLoading}
          maxHeight='200px'
          width='350px'
        />
      </OptionalFormFieldWrapper>
    </div>
  );
}